import { Badge } from "../ui/badge";
import { getTextPrimary, getTextSecondary, getHoverRowClass, getCardClass } from "../../lib/styleHelpers";

const STATUS_COLORS = {
  watching: { dark: "text-blue-400 bg-blue-500/10 border-blue-500/30", light: "text-blue-600 bg-blue-50 border-blue-200" },
  executed: { dark: "text-emerald-400 bg-emerald-500/10 border-emerald-500/30", light: "text-emerald-600 bg-emerald-50 border-emerald-200" },
  passed: { dark: "text-amber-400 bg-amber-500/10 border-amber-500/30", light: "text-amber-600 bg-amber-50 border-amber-200" },
  not_acted: { dark: "text-gray-400 bg-gray-500/10 border-gray-500/30", light: "text-gray-500 bg-gray-100 border-gray-200" },
};

export function DealRow({ deal, onViewOpportunity, isDark }) {
  const statusStyle = STATUS_COLORS[deal.pipeline_status] || STATUS_COLORS.not_acted;
  const badgeClass = isDark ? statusStyle.dark : statusStyle.light;

  return (
    <button
      onClick={() => onViewOpportunity(deal.opportunity_id)}
      className={`w-full text-left p-4 transition-colors ${getHoverRowClass(isDark)}`}
      data-testid={`deal-row-${deal.id}`}
    >
      <div className="flex items-start justify-between gap-4">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1 flex-wrap">
            <Badge variant="outline" className={`text-[10px] ${isDark ? "border-purple-500/30 text-purple-300" : "border-purple-300 text-purple-600"}`}>
              {deal.category?.split(" ")[0]}
            </Badge>
            <Badge className={`text-[10px] ${badgeClass}`}>
              {deal.pipeline_status?.replace("_", " ")}
            </Badge>
          </div>
          <p className={`text-sm font-bold truncate ${getTextPrimary(isDark)}`}>{deal.title}</p>
          <p className={`text-xs font-body line-clamp-1 mt-0.5 ${getTextSecondary(isDark)}`}>{deal.summary}</p>
        </div>
        <div className="text-right flex-shrink-0">
          <p className="text-xs font-bold text-emerald-400">{deal.estimated_roi}</p>
          <p className={`text-[10px] font-body ${getTextSecondary(isDark)}`}>
            {new Date(deal.created_at).toLocaleDateString()}
          </p>
        </div>
      </div>
    </button>
  );
}
